import React, { useState, useEffect, useContext } from "react";
import { MdLink, MdLinkOff, MdBlock } from "react-icons/md";
import linkBoxStyles from "../styles/linkBoxNotes.module.css";
import { reportContext, reportDispatchContext } from "./Report";
import { useSelector } from "react-redux";
import { getCurrentTime } from "../nexus/nexus.js";

const LinkBoxNotes = (props) => {
  const {
    commentid,
    isDetail,
    reportId,
    currentNotes,
    prId,
    catId,
    doRefresh,
    updateHistoryCommentDetail,
  } = props;

  const report = useContext(reportContext);
  const dispatchReport = useContext(reportDispatchContext);
  const [notes, setNotes] = useState(currentNotes);
  const currentUser = useSelector((state) => state.value);
  let currentUserName = "";
  if (currentUser) {
    currentUserName = currentUser.split(" (")[0];
  }
  useEffect(() => {
    if (report) {
      console.log(report.notes);
      setNotes(report.notes);
    }
  }, [report]);

  const handleUpdate = (noteId, comments, link) => {
    const updatedComments = link
      ? [commentid, ...comments]
      : comments.filter((id) => id !== commentid);
    const action = link ? "linked the note " : "unlinked the note ";
    dispatchReport({
      type: "UPDATE_NOTE_WITH_HISTORY",
      payload: {
        id: noteId,
        key: "comments",
        value: updatedComments,
        cid: commentid,
        prId: prId,
        catId: catId,
        action: action,
      },
    });

    const time = getCurrentTime();

    const history = {
      time: time,
      editor: currentUserName,
      action: action,
      field: "",
      value: noteId,
    };
    updateHistoryCommentDetail(history);
  };
  return (
    <div
      className={`${
        isDetail ? linkBoxStyles.linkboxModal : linkBoxStyles.linkbox
      }`}
    >
      {notes && notes.length === 0 ? (
        <div>No notes available for linking. Please add a note</div>
      ) : (
        notes.map((note, index) => {
          const isReportIncluded = note.reports.includes(reportId);
          const isCommentIncluded = note.comments.includes(commentid);
          const commentsStartingWithReportId = note.comments.filter((comment) =>
            comment.startsWith(reportId)
          );

          const isCommentLimitCrossed = commentsStartingWithReportId.length > 2;
          return (
            isReportIncluded &&
            note.id && (
              <div
                key={note.id}
                className={`${linkBoxStyles.row} ${
                  !isCommentIncluded ? "" : linkBoxStyles.unlocked
                }`}
                title={
                  isCommentIncluded
                    ? "Unlink the note"
                    : isCommentLimitCrossed
                    ? "This note has reached the max (5) number of linked comments."
                    : "Link the note"
                }
                onClick={() =>
                  handleUpdate(note.id, note.comments, !isCommentIncluded)
                }
              >
                <span className={linkBoxStyles.txtNote}>
                  {index + 1}. {note.id} -{" "}
                  {note.title.length > (isDetail ? 30 : 20)
                    ? `${note.title.slice(0, isDetail ? 30 : 20)}...`
                    : note.title}
                </span>

                <span className={!isCommentLimitCrossed ? linkBoxStyles.lockIcon :linkBoxStyles.blockIcon}>
                  {!isCommentIncluded ? (
                    <>
                      {!isCommentLimitCrossed ? (
                        <MdLink style={{ color: "#008000" }} />
                      ) : (
                        <MdBlock className={linkBoxStyles.blockedNote} />
                      )}
                    </>
                  ) : (
                    <MdLinkOff style={{ color: "#ff726f" }} />
                  )}
                </span>
              </div>
            )
          );
        })
      )}
    </div>
    // <div
    //   className={`${linkBoxStyles.linkbox} ${
    //     isDetail ? linkBoxStyles.linkboxModal : ""
    //   }`}
    // >
    //   {notes && notes.length === 0 ? (
    //     <div>No notes available for linking. Please add a note</div>
    //   ) : (
    //     notes.map((note, index) => {
    //       const isReportIncluded = note.reports.includes(reportId);
    //       const isCommentIncluded = note.comments.includes(commentid);
    //       const commentsStartingWithReportId = note.comments.filter((comment) =>
    //         comment.startsWith(reportId)
    //       );

    //       const isCommentLimitCrossed = commentsStartingWithReportId.length > 2;
    //       return (
    //         isReportIncluded &&
    //         note.id && (
    //           <div
    //             key={note.id}
    //             className={`${linkBoxStyles.row} ${
    //               !isCommentIncluded ? "" : linkBoxStyles.unlocked
    //             }`}
    //             title={
    //               isCommentIncluded
    //                 ? "Unlink the note"
    //                 : isCommentLimitCrossed
    //                 ? "This note has reached the max (5) number of linked comments."
    //                 : "Link the note"
    //             }
    //             onClick={() =>
    //               handleUpdate(note.id, note.comments, !isCommentIncluded)
    //             }
    //           >
    //             <span className={linkBoxStyles.txtNote}>
    //               {index + 1}. {note.id} -
    //               {note.title.length > 14
    //                 ? `${note.title.slice(0, 14)}...`
    //                 : note.title}
    //             </span>
    //             <span className={linkBoxStyles.lockIcon}>
    //               {!isCommentIncluded ? (
    //                 <>
    //                   {!isCommentLimitCrossed ? (
    //                     <MdLink style={{ color: "#008000" }} />
    //                   ) : (
    //                     <MdBlock className={linkBoxStyles.blockedNote} />
    //                   )}
    //                 </>
    //               ) : (
    //                 <MdLinkOff style={{ color: "#ff726f" }} />
    //               )}
    //             </span>
    //           </div>
    //         )
    //       );
    //     })
    //   )}
    // </div>
  );
};

export default LinkBoxNotes;
